var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollComponent",staticClass:"row position-relative",attrs:{"id":"scrollComponent"}},_vm._l((_vm.list),function(product){return _c('Product',{key:product.id,attrs:{"product":product},on:{"addProductToCart":_vm.addProductToCart}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }